var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.status === 0 && _vm.canRenderTask))?_c('div',{staticClass:"notice"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"img"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }